import React from 'react';
import TableSkeleton from 'components/TableSkeleton';

const TodayLessonsSkeleton = () => {
  return (
    <div className="container mx-auto mt-8 max-sm:px-4">
      <h5 className="typography-product-heading-compact-desktop mb-ds-xl">Today's Lessons</h5>
      <TableSkeleton layout="grid" rows={3} />
    </div>
  );
};

export default TodayLessonsSkeleton;
